<p-toast></p-toast>

<div class="prospect-form-page p-fluid">
    <app-page-shell>

        <app-page-hero eyebrow="CRM Pipeline" [title]="prospectId() ? 'Edit Prospect' : 'New Prospect'" subtitle="Qualify customer intake, contact details, address data, and compliance fields before client conversion.">
            <div actions>
                <p-button label="Cancel" icon="pi pi-times" severity="secondary" [text]="true" (click)="cancel()"></p-button>
                <p-button label="Save Prospect" icon="pi pi-save" [loading]="saving()" [disabled]="saving()" (click)="saveProspect()"></p-button>
            </div>
        </app-page-hero>

        <section class="form-shell">
            <form [formGroup]="prospectForm" class="prospect-form-grid">
                <app-page-form-section icon="pi pi-building" title="General" subtitle="Customer identity and prospect classification.">
                    <div class="section-grid">
                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="companyName" pInputText formControlName="companyName">
                                    <label for="companyName">Company Name *</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                            <small class="p-error" *ngIf="hasError('companyName')">Company name is required.</small>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-language"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="customerNameLocal" pInputText formControlName="customerNameLocal">
                                    <label for="customerNameLocal">Customer Name In Local Language</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>

                        <div class="field selector-field">
                            <label>Business Type *</label>
                            <p-selectButton [options]="businessTypes" formControlName="businessType" optionLabel="label" optionValue="value" styleClass="w-full"></p-selectButton>
                            <small class="p-error" *ngIf="hasError('businessType')">Business type is required.</small>
                        </div>

                        <div class="field roles-field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-tags"></i></p-inputGroupAddon>
                                <p-iftaLabel class="chips-ifta-label">
                                    <p-multiSelect
                                        inputId="prospectRoles"
                                        formControlName="roles"
                                        [options]="crmRoles()"
                                        optionLabel="label"
                                        optionValue="value"
                                        display="chip"
                                        [filter]="true"
                                        [showClear]="true"
                                        appendTo="body"
                                        styleClass="w-full roles-multiselect">
                                    </p-multiSelect>
                                    <label for="prospectRoles">Business Roles</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="natureOfBusiness" pInputText formControlName="natureOfBusiness">
                                    <label for="natureOfBusiness">Nature Of Business</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-globe"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="websiteURL" pInputText formControlName="websiteURL">
                                    <label for="websiteURL">Website</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                    </div>
                </app-page-form-section>

                <app-page-form-section icon="pi pi-user" title="Contact" subtitle="Primary communication contact for qualification and follow-up.">
                    <div class="section-grid">
                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="pocName" pInputText formControlName="pocName">
                                    <label for="pocName">Contact Person *</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                            <small class="p-error" *ngIf="hasError('pocName')">Contact person is required.</small>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-envelope"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="pocEmail" pInputText formControlName="pocEmail">
                                    <label for="pocEmail">Email Address</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                            <small class="p-error" *ngIf="hasError('pocEmail')">Enter a valid email address.</small>
                            <small class="p-error" *ngIf="hasContactMethodError()">Enter contact email, phone, or mobile.</small>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-phone"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="pocPhoneNumber" pInputText formControlName="pocPhoneNumber">
                                    <label for="pocPhoneNumber">Phone Number</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-mobile"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="mobileNumber" pInputText formControlName="mobileNumber">
                                    <label for="mobileNumber">Mobile Number</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                    </div>
                </app-page-form-section>

                <app-page-form-section icon="pi pi-map-marker" title="Address" subtitle="Structured address details used to prefill client conversion.">
                    <div class="section-grid">
                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-map"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="street1" pInputText formControlName="street1">
                                    <label for="street1">Street 1</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-language"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="street1Local" pInputText formControlName="street1Local">
                                    <label for="street1Local">Street 1 In Local Language</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-flag"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-select
                                        inputId="countryId"
                                        formControlName="countryId"
                                        [options]="countries()"
                                        optionLabel="name"
                                        optionValue="id"
                                        [filter]="true"
                                        filterBy="name,countryCode"
                                        [showClear]="true"
                                        styleClass="w-full">
                                    </p-select>
                                    <label for="countryId">Country</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="city" pInputText formControlName="city">
                                    <label for="city">City</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-language"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="cityLocal" pInputText formControlName="cityLocal">
                                    <label for="cityLocal">City In Local Language</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="postalCode" pInputText formControlName="postalCode">
                                    <label for="postalCode">Postal Code</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                    </div>
                </app-page-form-section>

                <app-page-form-section icon="pi pi-shield" title="Business / Compliance" subtitle="Qualification status, source, and registration data.">
                    <div class="section-grid">
                        <div class="field selector-field">
                            <label>Status</label>
                            <p-selectButton [options]="statuses" formControlName="status" optionLabel="label" optionValue="value" styleClass="w-full"></p-selectButton>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-compass"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="source" pInputText formControlName="source">
                                    <label for="source">Prospect Source</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>

                        <div class="field selector-field">
                            <label>Prospect Quality</label>
                            <p-selectButton [options]="prospectQualityOptions" formControlName="prospectQuality" optionLabel="label" optionValue="value" styleClass="w-full"></p-selectButton>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-receipt"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="taxRegNumber" pInputText formControlName="taxRegNumber">
                                    <label for="taxRegNumber">VAT / Tax Number</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-id-card"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input id="crNumber" type="number" pInputText formControlName="crNumber">
                                    <label for="crNumber">CR Number</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                    </div>
                </app-page-form-section>
            </form>
        </section>
    </app-page-shell>
</div>
